import { render, staticRenderFns } from "./ExistingCategories.vue?vue&type=template&id=810e5138&scoped=true&"
import script from "./ExistingCategories.vue?vue&type=script&lang=js&"
export * from "./ExistingCategories.vue?vue&type=script&lang=js&"
import style0 from "./ExistingCategories.vue?vue&type=style&index=0&id=810e5138&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810e5138",
  null
  
)

export default component.exports